module.exports = __webpack_public_path__ + "img/Swiper_old.ee92075f.png";